module.exports = __webpack_public_path__ + "static/media/poplar.89f2a09d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/poplar.jpg
// module id = 298
// module chunks = 0